/**
 * Application  user roles configuration
 */
define([], function permissionsAMD() {
  'use strict';
  var BASE = [
    'view_library',
    'view_book_player',
    'view_error',
    'view_comprehension_check',
    'view_comprehension_check_final'
  ];
  var permissions = {
    TEACHER: [
      'add_child',
      'add_student',
      'assign_book',
      'cancel_account',
      'change_email_button',
      'change_name_button',
      'change_name',
      'change_password_button',
      'change_password',
      'change_phone_number_button',
      'change_roster',
      'create_challenge',
      'delete_child',
      'edit_challenge',
      'edit_student_level',
      'edit_student_name',
      'edit_student',
      'home_header_text',
      'teacherDiscount', // special offer
      'view_button_my_account_customer_support',
      'view_button_my_account_invite_families',
      'view_button_my_account_manage_students',
      'view_button_my_account_my_profile',
      'view_button_remove_student',
      'view_button_upload_student',
      'view_categories_details',
      'view_categories',
      'view_challenge_report',
      'view_challenge',
      'view_change_user_my_shelf',
      'view_class_login_header',
      'view_class_login',
      'view_curriculum_overview',
      'view_customer_support',
      'view_home_header',
      'view_invitation_status',
      'view_invite_families_detail',
      'view_invite_families',
      'view_legal',
      'view_library_filters',
      'view_manage_students',
      'view_my_account_header_text',
      'view_my_account',
      'view_my_profile',
      'view_onboarding_manage_students',
      'view_onboarding',
      'view_rewards',
      'view_search_header',
      'view_search',
      'view_static_library_banner',
      'view_student_profile',
      'view_teacher_dashboard',
      'view_teacher_onboarding',
      'view_terms_and_conditions',
      'view_update_account_cancel_free',
      'view_update_account_cancel_teacher',
      'view_update_account',
      'view_upload_students'
    ],
    TEACHER_EMS: [
      'assign_book',
      'change_name_button',
      'change_name',
      'change_password',
      'create_challenge',
      'edit_challenge',
      'edit_student_level',
      'home_header_text',
      'view_button_my_account_customer_support',
      'view_button_my_account_invite_families',
      'view_button_my_account_manage_students',
      'view_button_my_account_my_profile',
      'view_categories_details',
      'view_categories',
      'view_challenge_report',
      'view_challenge',
      'view_change_user_my_shelf',
      'view_class_login_header',
      'view_class_login',
      'view_curriculum_overview',
      'view_customer_support',
      'view_home_header',
      'view_invitation_status',
      'view_invite_families_detail',
      'view_invite_families',
      'view_legal',
      'view_library_filters',
      'view_manage_students',
      'view_my_account_header_text',
      'view_my_account',
      'view_my_profile',
      'view_onboarding',
      'view_search_header',
      'view_search',
      'view_static_library_banner',
      'view_student_profile',
      'view_teacher_dashboard',
      'view_teacher_onboarding',
      'view_terms_and_conditions',
      'view_update_account_cancel_free',
      'view_update_account_cancel_teacher',
      'view_update_account',
      'view_upload_students'
    ],
    // TO DO have API add parent users as profiles so they can have permissions
    PARENT_FULL: [
      'view_my_shelf',
      'view_onboarding',
      'view_parent_onboarding',
      'view_placement_assessment',
      'view_select_profile'
    ],
    PARENT_FREE: [
      'view_onboarding',
      'view_parent_onboarding',
      'view_select_profile'
    ],
    CHILD_AT_SCHOOL: [
      'view_categories_details',
      'view_categories_header',
      'view_categories',
      'view_challenge_completed_coin',
      'view_change_avatar',
      'view_change_user_my_shelf_as_class_login',
      'view_change_user_my_shelf',
      'view_class_login',
      'view_home_header',
      'view_leaderboard',
      'view_level',
      'view_my_badges',
      'view_my_shelf_header',
      'view_my_shelf',
      'view_onboarding',
      'view_placement_assessment',
      'view_search_header',
      'view_search'
    ],
    EMS_STUDENT_AT_SCHOOL: [
      'view_categories_details',
      'view_categories_header',
      'view_categories',
      'view_challenge_completed_coin',
      'view_change_avatar',
      'view_change_user_my_shelf_as_class_login',
      'view_change_user_my_shelf',
      'view_class_login',
      'view_home_header',
      'view_leaderboard',
      'view_level',
      'view_my_badges',
      'view_my_shelf_header',
      'view_my_shelf',
      'view_onboarding',
      'view_placement_assessment',
      'view_search_header',
      'view_search'
    ],
    CHILD_PAID: [
      'add_child',
      'change_billing',
      'change_email_button',
      'change_password_button',
      'change_password',
      'delete_child',
      'view_button_my_account_curriculum_overview',
      'view_button_my_account_customer_support',
      'view_button_my_account_manage_account',
      'view_button_my_account_redeem_code',
      'view_categories_details',
      'view_categories_header',
      'view_categories',
      'view_challenge_completed_trophy',
      'view_change_avatar',
      'view_change_billing',
      'view_change_profile',
      'view_change_user_my_shelf',
      'view_curriculum_overview',
      'view_customer_support',
      'view_edit_profile',
      'view_home_header',
      'view_leaderboard',
      'view_legal',
      'view_level',
      'view_levels_header',
      'view_manage_subscription',
      'view_my_account_nav_bar',
      'view_my_account_profiles',
      'view_my_account',
      'view_my_badges',
      'view_my_profile',
      'view_my_shelf_header',
      'view_my_shelf',
      'view_onboarding',
      'view_parent_onboarding',
      'view_parent_settings_button',
      'view_placement_assessment',
      'view_redeem_code',
      'view_search_header',
      'view_search',
      'view_select_profile',
      'view_update_account_cancel_paid',
      'view_update_account_cancel',
      'view_update_account'
    ],
    CHILD_PAID_EMS_LINKED: [
      'change_billing',
      'change_email_button',
      'change_password_button',
      'change_password',
      'delete_child',
      'view_button_my_account_curriculum_overview',
      'view_button_my_account_customer_support',
      'view_button_my_account_manage_account',
      'view_categories_details',
      'view_categories_header',
      'view_categories',
      'view_challenge_completed_trophy',
      'view_change_avatar',
      'view_change_billing',
      'view_change_profile',
      'view_change_user_my_shelf',
      'view_curriculum_overview',
      'view_customer_support',
      'view_edit_profile',
      'view_home_header',
      'view_leaderboard',
      'view_legal',
      'view_level',
      'view_levels_header',
      'view_manage_subscription',
      'view_my_account_nav_bar',
      'view_my_account_profiles',
      'view_my_account',
      'view_my_badges',
      'view_my_profile',
      'view_my_shelf_header',
      'view_my_shelf',
      'view_onboarding',
      'view_parent_onboarding',
      'view_parent_settings_button',
      'view_placement_assessment',
      'view_redeem_code',
      'view_search_header',
      'view_search',
      'view_select_profile',
      'view_update_account_cancel_paid',
      'view_update_account_cancel',
      'view_update_account',
      'not_view_add_child'
    ],
    CHILD_PAID_CLASS_LINKED: [
      'add_child',
      'change_billing',
      'change_email_button',
      'change_password_button',
      'change_password',
      'delete_child',
      'view_button_my_account_curriculum_overview',
      'view_button_my_account_customer_support',
      'view_button_my_account_manage_account',
      'view_button_my_account_redeem_code',
      'view_categories_details',
      'view_categories_header',
      'view_categories',
      'view_challenge_completed_coin',
      'view_change_avatar',
      'view_change_billing',
      'view_change_profile',
      'view_change_user_my_shelf',
      'view_curriculum_overview',
      'view_customer_support',
      'view_edit_profile',
      'view_home_header',
      'view_leaderboard',
      'view_legal',
      'view_level',
      'view_levels_header',
      'view_manage_subscription',
      'view_my_account_nav_bar',
      'view_my_account_profiles',
      'view_my_account',
      'view_my_badges',
      'view_my_profile',
      'view_my_shelf_header',
      'view_my_shelf',
      'view_onboarding',
      'view_parent_onboarding',
      'view_parent_settings_button',
      'view_placement_assessment',
      'view_redeem_code',
      'view_search_header',
      'view_search',
      'view_select_profile',
      'view_teacher_shelf',
      'view_update_account_cancel_paid',
      'view_update_account_cancel',
      'view_update_account'
    ],
    CHILD_FREE_CLASS_LINKED: [
      'change_billing',
      'change_email_button',
      'change_password_button',
      'change_password',
      'view_book_intercept',
      'view_button_my_account_curriculum_overview',
      'view_button_my_account_customer_support',
      'view_button_my_account_manage_account',
      'view_categories_details',
      'view_categories_header',
      'view_categories',
      'view_challenge_completed_trophy',
      'view_change_avatar',
      'view_change_billing',
      'view_change_profile',
      'view_curriculum_overview',
      'view_customer_support',
      'view_edit_profile',
      'view_home_header',
      'view_leaderboard',
      'view_manage_subscription',
      'view_marketing_modal',
      'view_my_account_nav_bar',
      'view_my_account_profiles',
      'view_my_account',
      'view_my_badges',
      'view_my_profile',
      'view_my_shelf_header',
      'view_my_shelf',
      'view_onboarding',
      'view_parent_onboarding',
      'view_parent_settings_button',
      'view_placement_assessment',
      'view_search_header',
      'view_search',
      'view_select_profile',
      'view_teacher_shelf',
      'view_update_account_cancel_free',
      'view_update_account_cancel',
      'view_update_account'
    ],
    CHILD_FREE: [
      'change_billing',
      'change_email_button',
      'change_password_button',
      'change_password',
      'view_book_intercept',
      'view_button_my_account_curriculum_overview',
      'view_button_my_account_customer_support',
      'view_button_my_account_manage_account',
      'view_categories_details',
      'view_categories_header',
      'view_categories',
      'view_challenge_completed_trophy',
      'view_change_avatar',
      'view_change_billing',
      'view_change_profile',
      'view_curriculum_overview',
      'view_customer_support',
      'view_edit_profile',
      'view_home_header',
      'view_leaderboard',
      'view_manage_subscription',
      'view_marketing_modal',
      'view_my_account_nav_bar',
      'view_my_account_profiles',
      'view_my_account',
      'view_my_badges',
      'view_my_profile',
      'view_my_shelf_header',
      'view_my_shelf',
      'view_onboarding',
      'view_parent_onboarding',
      'view_parent_settings_button',
      'view_search_header',
      'view_search',
      'view_select_profile',
      'view_update_account_cancel_free',
      'view_update_account_cancel',
      'view_update_account'
    ],
    CHILD_PAID_LIMITED: [
      'add_child',
      'change_email_button',
      'change_password_button',
      'change_password',
      'delete_child',
      'view_button_my_account_curriculum_overview',
      'view_button_my_account_customer_support',
      'view_button_my_account_manage_account',
      'view_button_my_account_redeem_code',
      'view_categories_details',
      'view_categories_header',
      'view_categories',
      'view_challenge_completed_trophy',
      'view_change_avatar',
      'view_change_profile',
      'view_change_user_my_shelf',
      'view_curriculum_overview',
      'view_customer_support',
      'view_edit_profile',
      'view_home_header',
      'view_leaderboard',
      'view_legal',
      'view_level',
      'view_levels_header',
      'view_manage_subscription',
      'view_my_account_nav_bar',
      'view_my_account_profiles',
      'view_my_account',
      'view_my_badges',
      'view_my_profile',
      'view_my_shelf_header',
      'view_my_shelf',
      'view_onboarding',
      'view_parent_onboarding',
      'view_parent_settings_button',
      'view_placement_assessment',
      'view_redeem_code',
      'view_search_header',
      'view_search',
      'view_select_profile',
      'view_update_account'
    ],
    CHILD_PAID_LIMITED_EMS_LINKED: [
      'change_email_button',
      'change_password_button',
      'change_password',
      'delete_child',
      'view_button_my_account_curriculum_overview',
      'view_button_my_account_customer_support',
      'view_button_my_account_manage_account',
      'view_categories_details',
      'view_categories_header',
      'view_categories',
      'view_challenge_completed_trophy',
      'view_change_avatar',
      'view_change_profile',
      'view_change_user_my_shelf',
      'view_curriculum_overview',
      'view_customer_support',
      'view_edit_profile',
      'view_home_header',
      'view_leaderboard',
      'view_legal',
      'view_level',
      'view_levels_header',
      'view_manage_subscription',
      'view_my_account_nav_bar',
      'view_my_account_profiles',
      'view_my_account',
      'view_my_badges',
      'view_my_profile',
      'view_my_shelf_header',
      'view_my_shelf',
      'view_onboarding',
      'view_parent_onboarding',
      'view_parent_settings_button',
      'view_placement_assessment',
      'view_redeem_code',
      'view_search_header',
      'view_search',
      'view_select_profile',
      'view_update_account',
      'not_view_add_child'
    ],
    CHILD_PAID_LIMITED_CLASS_LINKED: [
      'add_child',
      'change_email_button',
      'change_password_button',
      'delete_child',
      'view_button_my_account_curriculum_overview',
      'view_button_my_account_customer_support',
      'view_button_my_account_manage_account',
      'view_button_my_account_redeem_code',
      'view_categories_details',
      'view_categories_header',
      'view_categories',
      'view_challenge_completed_coin',
      'view_change_avatar',
      'view_change_profile',
      'view_change_user_my_shelf',
      'view_curriculum_overview',
      'view_customer_support',
      'view_edit_profile',
      'view_home_header',
      'view_leaderboard',
      'view_legal',
      'view_level',
      'view_levels_header',
      'view_manage_subscription',
      'view_my_account_nav_bar',
      'view_my_account_profiles',
      'view_my_account',
      'view_my_badges',
      'view_my_profile',
      'view_my_shelf_header',
      'view_my_shelf',
      'view_onboarding',
      'view_parent_onboarding',
      'view_parent_settings_button',
      'view_placement_assessment',
      'view_redeem_code',
      'view_search_header',
      'view_search',
      'view_select_profile',
      'view_teacher_shelf',
      'view_update_account'
    ]
  };

  function getUserPermissions(userType) {
    if (!permissions[userType]) {
      console.warn(
        'User Type could not be found. Could not get permissions for ' +
          userType
      );
      return [];
    }
    return BASE.concat(permissions[userType]);
  }

  /**
   * @param {String} role User role
   * @param {string|string[]} permissions User permissions
   **/
  function addPermissions(role, permissions) {
    if (Array.isArray(permissions[role])) {
      // eslint-disable-next-line no-undef
      permissions[role] = permissions[role].concat(permissions);
    } else {
      console.error(
        'Cannot set permissions, user role not found',
        role,
        permissions
      );
    }
  }
  return {
    getUserPermissions: getUserPermissions,
    addPermissions: addPermissions
  };
});
